import { render, staticRenderFns } from "./ConsultationPrescriptionRecord.vue?vue&type=template&id=0cee806c&scoped=true&"
import script from "./ConsultationPrescriptionRecord.vue?vue&type=script&lang=js&"
export * from "./ConsultationPrescriptionRecord.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationPrescriptionRecord.vue?vue&type=style&index=0&id=0cee806c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cee806c",
  null
  
)

export default component.exports